import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-justinfo',
  templateUrl: 'justinfo.html',
})
export class JustinfoPage {

  text: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http
  ) {

    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    loadingPopup.present();
    console.log(this.params.apiURL + '?act=justinfo');
    this.http.get(this.params.apiURL + '?act=justinfo')
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
            //console.log(data);
            this.text = data.text;

            console.log('text: ' + this.text);

            loadingPopup.dismiss();

        },

        err => {
          loadingPopup.dismiss();
          //this.error = "1";
        }

      );

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JustinfoPage');
  }

  ionViewWillEnter() {
    this.params.stat('justinfo');    
  }   

}



// WEBPACK FOOTER //
// ./src/pages/justinfo/justinfo.ts